import { useMutation } from 'react-query';
import { trpc } from '../../../../lib/trpc';

const useUpdateSpaceProductSort = () => {
    return useMutation(async (params: { id: number }[]) => {
        const ids = params.map((item) => item.id);
        return trpc.ProductsApi.updateSpaceProductSort.mutate({ entityIds: ids });
    });
};

export default useUpdateSpaceProductSort;
